import { createSlice } from '@reduxjs/toolkit';
import { GetShipmentManifestState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getShipmentManifestThunk } from './thunks';

// Initial State
const initialState: GetShipmentManifestState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getShipmentManifestSlice = createSlice({
  name: 'getShipmentManifest',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    manifestDownloadReset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getShipmentManifestThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getShipmentManifestThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getShipmentManifestThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { manifestDownloadReset, setValues } = getShipmentManifestSlice.actions;
export * from './thunks';
export * from './selectors';
export default getShipmentManifestSlice.reducer;
